import { DateTime } from 'luxon'

type FormatSemiMonthlyNameType = {
  startDate: DateTime
  endDate: DateTime
}
const formatSemiMonthlyName = ({
  startDate,
  endDate
}: FormatSemiMonthlyNameType) => {
  return `${startDate.toFormat('MMMM')} ${startDate.toFormat('d')}-${endDate.toFormat('d')}, ${startDate.toFormat('yyyy')}`
}

const formatMonthlyName = ({ startDate }: { startDate: DateTime }) => {
  return startDate.toFormat('MMMM yyyy')
}

type BuildTimeObjectType = {
  startDate: string
  endDate: string
  formatDisplayName: ({
    startDate,
    endDate
  }: FormatSemiMonthlyNameType) => string
}

const buildTimeObject = ({
  startDate,
  endDate,
  formatDisplayName
}: BuildTimeObjectType) => {
  const dtStart = DateTime.fromFormat(startDate, 'dd-MM-yyyy')
  const dtEnd = DateTime.fromFormat(endDate, 'dd-MM-yyyy')

  return {
    name: formatDisplayName({ startDate: dtStart, endDate: dtEnd }),
    startAt: dtStart.toISODate(),
    endAt: dtEnd.toISODate(),
    year: dtStart.year
  }
}

type FormatMonthsType = {
  startDate: string
}

const formatSemiMonths = ({ startDate }: FormatMonthsType) => {
  const firstMonth = DateTime.fromISO(startDate).startOf('month')
  const now = DateTime.now().startOf('month')
  const monthRange: DateTime[] = []
  let cursor = firstMonth

  while (cursor <= now) {
    monthRange.push(cursor)
    cursor = cursor.plus({ months: 1 })
  }

  const semiMonths: Record<string, string | null | number>[] = []
  for (const month of monthRange) {
    const firstHalf = buildTimeObject({
      startDate: month.startOf('month').toFormat('dd-MM-yyyy'),
      endDate: month.set({ day: 15 }).toFormat('dd-MM-yyyy'),
      formatDisplayName: formatSemiMonthlyName
    })

    const secondHalf = buildTimeObject({
      startDate: month.set({ day: 16 }).toFormat('dd-MM-yyyy'),
      endDate: month.endOf('month').toFormat('dd-MM-yyyy'),
      formatDisplayName: formatSemiMonthlyName
    })

    semiMonths.unshift({
      ...firstHalf,
      id: `${firstHalf.startAt},${firstHalf.endAt}`
    })
    semiMonths.unshift({
      ...secondHalf,
      id: `${secondHalf.startAt},${secondHalf.endAt}`
    })
  }

  return semiMonths
}

const formatMonths = ({ startDate }: FormatMonthsType) => {
  const firstMonth = DateTime.fromISO(startDate).startOf('month')
  const now = DateTime.now().startOf('month')
  const monthRange: DateTime[] = []
  let cursor = firstMonth

  while (cursor <= now) {
    monthRange.push(cursor)
    cursor = cursor.plus({ months: 1 })
  }

  const months: Record<string, string | null | number>[] = []

  for (const month of monthRange) {
    const monthObject = buildTimeObject({
      startDate: month.startOf('month').toFormat('dd-MM-yyyy'),
      endDate: month.endOf('month').toFormat('dd-MM-yyyy'),
      formatDisplayName: formatMonthlyName
    })

    months.push({
      ...monthObject,
      id: `${monthObject.startAt},${monthObject.endAt}`
    })
  }

  return months.reverse()
}

export { formatSemiMonths, formatMonths }
